import { LoadingStates } from '@pb/utils'

const initialState = {
  updateDeliveryModesStatus: LoadingStates.NotLoaded,
  contextStatus: LoadingStates.NotLoaded,
  prepareStatus: LoadingStates.NotLoaded,
  patchPaymentStatus: LoadingStates.NotLoaded,
  customerDetailsStatus: LoadingStates.NotLoaded,
  pickupPointsStatus: LoadingStates.NotLoaded,
  CnCPointsStatus: LoadingStates.NotLoaded,
  deliverySpeedSelectionStatus: LoadingStates.NotLoaded,
  addressRequestStatus: LoadingStates.NotLoaded,
  giftCardsStatus: LoadingStates.NotLoaded,
  postProceedStatus: LoadingStates.NotLoaded,
  editItemQuantityStatus: { status: LoadingStates.NotLoaded, id: '' },
  parcelToShowInProductDetails: '',
  shouldShowErrorScreen: false,
  errors: [],
  customer: {},
  cart: {},
  paymentData: {},
  orderTotals: {},
  delivery: {
    availableDeliverySpeeds: [],
    selectedDeliveryMethod: null,
    selectedDeliverySpeed: null,
    lastUsedPUPPostalCode: null,
    preselectedPickupPlace: '',
  },
  payment: {
    availablePaymentMethods: [],
    adyenApplePayPaymentMethodData: {},
  },
  ui: {
    parcels: {
      isSplitOrderModalOpen: false,
      isHMDeliveryModalOpen: false,
      isExternalDeliveryModalOpen: false,
    },
    vatNumberChecked: false,
  },
  settings: {},
  additionalInfo: {},
}

export default initialState
